import { render, staticRenderFns } from "./layout5.vue?vue&type=template&id=34ee2e86&"
import script from "./layout5.vue?vue&type=script&lang=js&"
export * from "./layout5.vue?vue&type=script&lang=js&"
import style0 from "./layout5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports